import { Directive, ElementRef, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { ClientEnvironment, ENVIRONMENT } from '@thehubz/client/core';

// declare AwsWafCaptcha so that it can be used in this directive
declare const AwsWafCaptcha: any;

@Directive({
  selector: '[thehubzAwsCaptcha]',
  standalone: true,
})
/**
 * This directive is used to add the AWS captcha to a page/component.
 */
export class AwsCaptchaDirective implements OnInit {
  @Output() captchaSuccess = new EventEmitter<string>();
  @Output() captchaError = new EventEmitter<string>();

  constructor(private readonly elementRef: ElementRef, @Inject(ENVIRONMENT) private readonly env: ClientEnvironment) {}

  ngOnInit(): void {
    AwsWafCaptcha.renderCaptcha(this.elementRef.nativeElement, {
      apiKey: this.env.captchaApiKey,
      onSuccess: (token: string) => {
        this.captchaSuccess.emit(token);
      },
      onError: (error: string) => {
        console.log('Captcha error: ', error);
        this.captchaError.emit(error);
      },
      dynamicWidth: false,
      skipTitle: true,
      defaultLocale: 'en-US',
    });
  }
}
